import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile } from '@/models';

@Component({
  name: 'CmgCustomerGreeting'
})
export default class CmgCustomerGreeting extends Vue {

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return  profile && !profile.isGuest ? profile : null;
  }

  get customerName(): string {
    if (this.customer !== null && this.customer !== undefined && this.customer?.firstName?.length > 9) {
      return this.customer?.firstName.substring(0, 9) + "...";
    } else return this.customer?.firstName ?? "";
  }
}
